import moment from 'moment';
import { interval } from 'rxjs';
import { map } from 'rxjs/operators';
import { Helpers } from '@/common/helpers';

export const clockObservable$ = interval(1000)
	.pipe(
		map(() => Helpers.isUiTest() ? Date.parse('2030-09-30'): Date.now())
	);

export const ClockService = {
	pause(waitTime) {
		return new Promise(function(resolve) {
			setTimeout(function() {resolve(waitTime);},waitTime);
		});
	}
};

export function dateProvider() {
	return Helpers.isUiTest() ? Date.parse('2030-09-30'): Date.now();
}

export function momentProvider() {
	return Helpers.isUiTest() ? moment('2030-09-30', 'YYYY-MM-DD') : moment();
}
